import { Skeleton } from "@/components/shared/Skeleton";

export function LiveModeButtonSkeleton() {
  return (
    <Skeleton className="h-10 w-full rounded-lg shadow-md border border-slate-200 bg-white/80" />
  );
}
